import { css } from '@emotion/react';

export const boxShadow = {
  shadow_header: css`
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
  `,
};
